import axios from 'axios'

export const SpeechesService = {
    loadSpeeches: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/speeches')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    saveSpeeches: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/speeches', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/services/speeches-service.js